<template>
  <div class="pagoda-form-edit-item">
    <el-tooltip
      :disabled="!textOverflow"
      placement="top"
      effect="light"
    >
      <template slot="content">
        {{elForm.model[prop]}}
      </template>
      <span
        class="pagoda-form-edit-item__content"
        v-show="!editabled && !submiting && !isEmpty(elForm.model[prop])"
        ref="content"
      >
        <slot name="text">
          {{elForm.model[prop]}}
        </slot>
      </span>
    </el-tooltip>
    <div
      v-show="editabled && !submiting"
      style="flex: 1"
    >
      <slot></slot>
    </div>
    <div
      class="pagoda-form-edit-item-controller"
      :class="{'pagoda-form-edit-item-controller--editing': editabled}"
    >
      <i
        class="el-icon-loading"
        v-show="submiting"
      ></i>
      <i
        class="el-icon-close"
        v-show="!submiting && editabled"
        @click="handleCancel"
      ></i>
      <i
        class="el-icon-check"
        v-show="!submiting && editabled"
        @click="handleSave"
      ></i>
      <i
        class="el-icon-edit-outline"
        v-show="!submiting && !editabled"
        @click="handleEdit"
      ></i>
    </div>
  </div>
</template>

<script>
import { isEmpty, isObject, isArray } from '../../utils'

export default {
  name: 'FormEditItem',
  props: {
    prop: String
  },
  inject: ['elForm'],
  data() {
    return {
      submiting: false,
      editabled: false,
      textOverflow: false
    }
  },
  created() {
    this.$pagoda.$on('form-edit-item:edit', (elFormInstance, self) => {
      if (elFormInstance === this.elForm && self !== this && this.editabled && !this.submiting) {
        this.handleCancel()
      }
    })
  },
  mounted() {
    this.checkTextOverflow()
  },
  methods: {
    isEmpty,
    handleEdit() {
      this.$pagoda.$emit('form-edit-item:edit', this.elForm, this)
      this.editabled = true
      const newVal = this.elForm.model[this.prop]
      this.cacheValue =
        isObject(newVal) || isArray(newVal)
          ? JSON.parse(JSON.stringify(this.elForm.model[this.prop]))
          : newVal

      this.$nextTick(this.focus)
    },
    handleCancel() {
      this.elForm.model[this.prop] = this.cacheValue

      this.clearValidate(() => {
        this.editabled = false

        this.elForm.$emit('edit-cancel', this.prop)
      })
    },
    handleSave() {
      const save = () =>
        this.clearValidate(() => {
          this.submiting = true

          this.elForm.$emit(
            'edit-save',
            this.prop,
            () => {
              this.submiting = false
              this.editabled = false

              this.$nextTick(this.checkTextOverflow)
            },
            () => {
              this.submiting = false
            }
          )
        })

      if (this._events['before-edit-save'] || this._events['beforeEditSave']) {
        this.elForm.$emit('before-edit-save', this.prop, save)
        this.elForm.$emit('beforeEditSave', this.prop, save)
      } else {
        save()
      }
    },
    checkTextOverflow() {
      const { content } = this.$refs

      this.textOverflow = content.scrollWidth > content.clientWidth
    },
    clearValidate(cb) {
      this.elForm.clearValidate([this.prop])

      setTimeout(cb, 60)
    },
    focus() {
      const editItem = this.$children[0]

      editItem && editItem.focus && editItem.focus()
    }
  }
}
</script>
